
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  listItemRename: {
    id: "ListItem.rename",
    defaultMessage: "Rename",
  },
  listItemDuplicate: {
    id: "ListItem.duplicate",
    defaultMessage: "Duplicate",
  },
  listItemDelete: {
    id: "ListItem.delete",
    defaultMessage: "Delete",
  },
  listItemArchive: {
    id: "ListItem.archive",
    defaultMessage: "Archive",
  },
  listItemUnarchive: {
    id: "ListItem.unarchive",
    defaultMessage: "Restore",
  },
  listItemMakeOrder: {
    id: "ListItem.order",
    defaultMessage: "Make Order",
  },
  listItemShowOrder: {
    id: "ListItem.orderShow",
    defaultMessage: "Show Order",
  },
  listItemLinkTitle: {
    id: "ListItem.linkTitle",
    defaultMessage: "Settings",
  },
  listItemOrderPdf: {
    id: "ListItem.orderPdf",
    defaultMessage: "Download configuration",
  },
  listItemManufacturingPdf: {
    id: "ListItem.manufacturingPdf",
    defaultMessage: "Download drawing",
  },
  listItemTroughPdf: {
    id: "ListItem.troughPdf",
    defaultMessage: "Download technical drawing",
  },
  listItemDownloadPdfs: {
    id: "ListItem.downloadPdfs",
    defaultMessage: "Download PDFs",
  },
  listItemMoveToGroup: {
    id: "ListItem.moveToGroup",
    defaultMessage: "Move to Folder",
  },
  listItemGoBack: {
    id: "ListItem.goBack",
    defaultMessage: "Go back",
  },
  listItemMoveToThisGroup: {
    id: "ListItem.moveToThisGroup",
    defaultMessage: "Move to this folder",
  },
  listItemMoveToDashboard: {
    id: "ListItem.moveToDashboard",
    defaultMessage: "Move to Dashboard",
  }
});

export default MESSAGES;